import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';

export default function Login() {
  const { user, loading, signInWithGoogle, devLogin } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!loading && user) navigate('/', { replace: true });
  }, [user, loading, navigate]);

  const handleDevLogin = async () => {
    try {
      await devLogin();
      navigate('/', { replace: true });
    } catch (e) {
      setError(e.response?.data?.error || e.message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-sm bg-white border border-border rounded-2xl p-8 shadow-sm">
        <div className="flex flex-col items-center mb-6">
          <div className="w-12 h-12 rounded-xl bg-ink text-white flex items-center justify-center font-medium mb-3">
            AI
          </div>
          <h1 className="text-xl font-medium">Sign in</h1>
          <p className="text-sm text-muted mt-1">Use your company Google account</p>
        </div>

        <button
          onClick={signInWithGoogle}
          className="w-full flex items-center justify-center gap-2 border border-border rounded-lg py-2.5 text-sm font-medium hover:bg-neutral-50 transition"
        >
          <GoogleIcon />
          Continue with Google
        </button>

        <p className="text-xs text-muted text-center mt-4">
          Only members of your Workspace can access this launcher.
        </p>

        {import.meta.env.DEV && (
          <div className="mt-6 pt-4 border-t border-border">
            <button
              onClick={handleDevLogin}
              className="w-full text-xs text-muted hover:text-ink py-2"
            >
              🔧 Dev login (bypasses Google — local only)
            </button>
          </div>
        )}

        {error && <p className="text-xs text-red-600 text-center mt-3">{error}</p>}
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18">
      <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.49h4.84a4.14 4.14 0 0 1-1.79 2.71v2.26h2.9c1.7-1.56 2.69-3.87 2.69-6.62z"/>
      <path fill="#34A853" d="M9 18c2.43 0 4.47-.81 5.96-2.18l-2.9-2.26c-.8.54-1.83.86-3.06.86a5.36 5.36 0 0 1-5.04-3.71H.96v2.33A9 9 0 0 0 9 18z"/>
      <path fill="#FBBC05" d="M3.96 10.71A5.41 5.41 0 0 1 3.68 9c0-.59.1-1.17.28-1.71V4.96H.96A9 9 0 0 0 0 9c0 1.45.35 2.83.96 4.04l3-2.33z"/>
      <path fill="#EA4335" d="M9 3.58c1.32 0 2.51.45 3.44 1.35l2.58-2.58A9 9 0 0 0 9 0 9 9 0 0 0 .96 4.96l3 2.33A5.36 5.36 0 0 1 9 3.58z"/>
    </svg>
  );
}
